import type { ReactNode } from 'react'

interface Props {
  stepKey: number | string
  children: ReactNode
}

export default function StepTransition({ stepKey, children }: Props) {
  return (
    <div key={stepKey} className="animate-step-slide-in">
      {children}
    </div>
  )
}
